import apiUrl from '../../../constants'
import axios from 'axios'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import RTODTOLabel from './RTODTOLabel/index.vue';
import DTOFlyer from './DTOFlyer/index.vue';
import CryptoJS from "crypto-js";

export default {
  name: 'vendor-company-master',
  components: {
    DatePicker,
    'first': RTODTOLabel,
    'second': DTOFlyer
  },
  props: [],
  data() {
    return {
      isDisabled: false,
      currentTab: this.$route.query.currentTab || 'First',
      componentKey: 0,
      tabs: [{
          key: 'First',
          value: 'RTO / DTO Print Label'
        },
        {
          key: 'Second',
          value: 'Link DTO AWB and Flyer'
        }
      ],
    }
  },
  computed: {
    // selects all checkbox's option
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  //HUb-6220 | PXB-6031: Single Page flow for Printing & Linking Sticker- Hubops
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('permissiondata')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var permissiondata = JSON.parse(plaintext);
 
    for(let i = 0; i < permissiondata.length; i++) {
      let data = permissiondata[i];
      let menuItem = data.name.replace(/\s+/g, '').toLowerCase();
      if (menuItem === "printsticker"){
        window.open("https://lastmileallocationpod-app.xbees.in/#/PrintLabelv2", '_blank');
         this.isDisabled = true; // Disable current page
         break;
      }
  }
     
  },
  methods: {}
}



// WEBPACK FOOTER //
// ./src/views/components/DTOstickering/DTOstickering.js